export default __webpack_public_path__ + "assets/images/67d4be3b3bff6b01844de57d605dfa95.png";